import { render, staticRenderFns } from "./SendEmail.vue?vue&type=template&id=cd234348&"
import script from "./SendEmail.vue?vue&type=script&lang=ts&"
export * from "./SendEmail.vue?vue&type=script&lang=ts&"
import style0 from "./SendEmail.vue?vue&type=style&index=0&id=cd234348&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports